import { render } from "./BaseMoveToControl.vue?vue&type=template&id=5568a12e"
import script from "./BaseMoveToControl.vue?vue&type=script&lang=js"
export * from "./BaseMoveToControl.vue?vue&type=script&lang=js"

import "./BaseMoveToControl.vue?vue&type=style&index=0&id=5568a12e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__